import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectQueryKeys } from '../constants'

export const useGetProjectDetailsQuery = ({
  projectId,
  expand = '',
  options
}) => {
  const handleQuery = async () => {
    const config = {
      method: 'get',
      params: {
        expand
      }
    }

    const { data } = await api(`/api/v2/projects/${projectId}`, config)

    return data
  }

  return useQuery({
    queryKey: [projectQueryKeys.GET_PROJECT_QUERY, projectId, expand],
    queryFn: handleQuery,
    retry: 0,
    enabled: !!projectId,
    ...options
  })
}
